/* eslint-disable max-lines */
import {
  Bars3Icon,
  BellIcon,
  BriefcaseIcon,
  BuildingStorefrontIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  CircleStackIcon,
  ClockIcon,
  CubeIcon,
  CurrencyDollarIcon,
  DevicePhoneMobileIcon,
  DocumentTextIcon,
  GiftIcon,
  HomeIcon,
  InformationCircleIcon,
  LinkIcon,
  MapIcon,
  MapPinIcon,
  NewspaperIcon,
  NoSymbolIcon,
  StarIcon,
  TagIcon,
  UserGroupIcon,
  UsersIcon,
  WrenchScrewdriverIcon
} from "@heroicons/react/24/outline";
import Can from "../../users/permissions/Can";
import SuperAdmin from "../../users/permissions/SuperAdmin";
import Item from "./Item";
import VideoTutorials from "./VideoTutorials";

const Body: React.FC = () => {
  return (
    <>
      <ul className="select-none w-full md:pl-3">
        <SuperAdmin>
          <Item
            crumbs={["Gjirafa Dashboard"]}
            href="/dashboard-gjirafa"
            name="Operator Dashboard"
            icon={<HomeIcon />}
          />
        </SuperAdmin>
        <Item
          crumbs={["Dashboard"]}
          href="/"
          name="Ballina"
          icon={<HomeIcon />}
        />
        <Can permissions="reservation.ticket.read">
          <Item
            crumbs={["Rezervimet"]}
            href="/office"
            name="Rezervimet"
            icon={<BuildingStorefrontIcon />}
          />
        </Can>

        <Can permissions={["reservation.old.ticket.read"]}>
          <Item
            crumbs={["Rezervimet"]}
            name="Menaxhimi i shitjeve"
            icon={<UsersIcon strokeWidth={1} />}
          >
            <Can permissions="reservation.old.ticket.read">
              <Item
                crumbs={["Rezervimet", "Version 2.0"]}
                href="/ticket/reservations"
                name="Rezervimet Online"
                icon={<CircleStackIcon />}
              />
            </Can>
          </Item>
        </Can>
        <Can
          permissions={[
            "route.line.read",
            "route.trip.read",
            "pricings.pricing.read",
            "tripnotices.tripnotice.read",
            "route.announcement.read"
          ]}
        >
          <Item
            crumbs={["Menaxhimi i linjave"]}
            name="Menaxhimi i linjave"
            icon={<Bars3Icon />}
          >
            <Can permissions="route.line.read">
              <Item
                crumbs={["Menaxhimi i linjave", "Linjat"]}
                href="/lines"
                name="Linjat"
              />
            </Can>
            <Can permissions="route.trip.read">
              <Item
                crumbs={["Menaxhimi i linjave", "Oraret"]}
                href="/trips"
                name="Oraret"
              />
            </Can>
            <Can permissions="pricings.pricing.read">
              <Item
                crumbs={["Menaxhimi i linjave", "Çmimet"]}
                href="/prices"
                name="Çmimet"
              />
            </Can>
            <Can permissions="tripnotices.tripnotice.read">
              <Item
                crumbs={["Informata për oraret"]}
                href="/notices"
                name="Informata për oraret"
              />
            </Can>
            <Can permissions="route.announcement.read">
              <Item
                crumbs={["Informatat për linja"]}
                href="/announcements"
                name="Informatat për linja"
                icon={<InformationCircleIcon />}
              />
            </Can>
            <SuperAdmin>
              <Item
                crumbs={["Menaxhimi i linjave", "Rezervimet e bllokuara për orar"]}
                href="/trip-reservability"
                name="Rezervimet e bllokuara për orar"
              />
            </SuperAdmin>
          </Item>
        </Can>
        <Can permissions={["esims.esim.read"]}>
          <Item crumbs={["Esim"]} name="Esim" icon={<DevicePhoneMobileIcon />}>
            <SuperAdmin>
              <Item
                crumbs={["Esim", "Dashboard"]}
                href="/esim/dashboard"
                name="Dashboard"
                icon={<ChartBarIcon />}
              />
            </SuperAdmin>
            <Can permissions="esims.esim.read">
              <Item
                crumbs={["Esim", "Shitjet"]}
                href="/esim/reservations"
                name="Shitjet"
                icon={<CircleStackIcon />}
              />
            </Can>
            <SuperAdmin>
              <Item
                crumbs={["Esim", "Paketat"]}
                href="/esim/packages"
                name="Paketat"
                icon={<CubeIcon />}
              />
            </SuperAdmin>
            <SuperAdmin>
              <Item
                crumbs={["Esim", "Njoftimet"]}
                href="/esim/broadcasts"
                name="Njoftimet"
                icon={<BellIcon />}
              />
            </SuperAdmin>
            <Can permissions="vouchers.vouchercode.read">
              <Item
                crumbs={["Esim", "Voucher Codes"]}
                href="/esim/voucher-codes"
                name="Voucher Codes"
                icon={<GiftIcon />}
              />
            </Can>
            <Can permissions="esim.partner.partner.read">
              <Item
                crumbs={["Esim", "Partneret"]}
                href="/esim-partners"
                name="Partneret"
                icon={<BriefcaseIcon />}
              />
            </Can>
          </Item>
        </Can>
        <Can
          permissions={[
            "travelbundles.travelbundle.read",
            "travelbundles.travelbundle.reservation.read",
            "travelbundles.travelbundle.include.read",
            "travelbundles.travelbundle.diplayorder.read"
          ]}
        >
          <Item
            crumbs={["Menaxhimi i ofertave"]}
            name="Menaxhimi i ofertave"
            icon={<CubeIcon strokeWidth={1} />}
          >
            <Can permissions="travelbundles.travelbundle.read">
              <Item
                crumbs={["Menaxhimi i ofertave", "Ofertat e udhëtimit"]}
                href="/bundles/manage"
                name="Ofertat e udhëtimit"
              />
            </Can>
            <Can permissions="travelbundles.travelbundle.reservation.read">
              <Item
                crumbs={["Menaxhimi i ofertave", "Rezervimet e ofertave"]}
                href="/bundles/reservations"
                name="Rezervimet e ofertave"
              />
            </Can>
            <Can permissions="travelbundles.travelbundle.diplayorder.read">
              <Item
                crumbs={["Menaxhimi i ofertave", "Renditja e ofertave "]}
                href="/bundles/order"
                name="Renditja e ofertave "
              />
            </Can>
            <Can permissions="travelbundles.travelbundle.include.read">
              <Item
                crumbs={["Menaxhimi i ofertave", "Veçoritë e ofertave"]}
                href="/bundles/features"
                name="Veçoritë e ofertave"
              />
            </Can>
          </Item>
        </Can>
        <Can
          permissions={[
            "userroles.userrole.read",
            "users.user.read",
            "permissions.permission.read"
          ]}
        >
          <Item
            crumbs={["Menaxhimi i roleve"]}
            name="Menaxhimi i roleve"
            icon={<UsersIcon strokeWidth={1} />}
          >
            <Can permissions="userroles.userrole.read">
              <Item
                crumbs={["Menaxhimi i roleve", "Rolet"]}
                href="/users/roles"
                name="Rolet"
              />
            </Can>
            <Can permissions="users.user.read">
              <Item
                crumbs={["User overview", "Users"]}
                href="/users/overview"
                name="User overview"
              />
            </Can>
            <Can permissions="permissions.permission.read">
              <Item
                crumbs={["Access control list"]}
                href="/users/access"
                name="Access control list"
              />
            </Can>
          </Item>
        </Can>
        <Can permissions="blogs.blog.read">
          <Item
            crumbs={["Blogu i udhëtimeve"]}
            href="/blogs"
            name="Blogu"
            icon={<NewspaperIcon />}
          />
        </Can>
        <Can permissions="reviews.review.read">
          <Item
            crumbs={["Reviews"]}
            href="/reviews"
            name="Reviews"
            icon={<StarIcon />}
          />
        </Can>
        <Can permissions="linepages.linepage.read">
          <Item
            crumbs={["Line Pages"]}
            href="/line-pages"
            name="Line Pages"
            icon={<Bars3Icon />}
          />
        </Can>
        <Can permissions="citypages.citypage.read">
          <Item
            crumbs={["City Pages"]}
            href="/city-pages"
            name="City Pages"
            icon={<MapPinIcon />}
          />
        </Can>
        <Can permissions="promotioncodes.promotioncode.read">
          <Item
            crumbs={["Kodet promocionale"]}
            href="/promotioncodes"
            name="Kodet promocionale"
            icon={<TagIcon />}
          />
        </Can>
        <Can permissions={["affiliates.affiliate.read", "affiliates.payout.read"]}>
          <Item
            crumbs={["Partneret affiliate"]}
            name="Partneret affiliate"
            icon={<LinkIcon />}
          >
            <Can permissions="affiliates.affiliate.read">
              <Item
                crumbs={["Partneret affiliate", "Te gjithe partneret"]}
                href="/affiliates"
                name="Te gjithe partneret"
                end
              />
            </Can>
            <Can permissions="affiliates.payout.read">
              <Item
                crumbs={["Partneret affiliate", "Kerkesat per pagese"]}
                href="/affiliates/payouts"
                name="Kerkesat per pagese"
              />
            </Can>
            <Can permissions="affiliates.affiliate.read">
              <Item
                crumbs={["Partneret affiliate", "Pasqyra financiare"]}
                href="/affiliates/financial-summary"
                name="Pasqyra financiare"
              />
            </Can>
          </Item>
        </Can>
        <Can permissions="operators.operator.read">
          <Item
            crumbs={["Operatorët"]}
            href="/operators"
            name="Operatorët"
            icon={<UserGroupIcon />}
          />
        </Can>
        <Can permissions="locations.station.read">
          <Item
            crumbs={["Stacionet"]}
            href="/locations"
            name="Stacionet"
            icon={<MapPinIcon />}
          />
        </Can>
        <SuperAdmin>
          <Item
            crumbs={["Operatoret", "Ndrysho operatorin"]}
            href="/operator/change"
            name="Ndrysho operatorin"
            icon={<BriefcaseIcon />}
          />
        </SuperAdmin>
        <SuperAdmin>
          <Item
            crumbs={["Blocked Users"]}
            href="/blocked-users"
            name="Blocked Users"
            icon={<NoSymbolIcon />}
          />
        </SuperAdmin>
        <SuperAdmin>
          <Item
            crumbs={["Service Fees"]}
            href="/service-fees"
            name="Service Fees"
            icon={<CurrencyDollarIcon />}
          />
        </SuperAdmin>
        <SuperAdmin>
          <Item
            crumbs={["Reservation Thresholds"]}
            href="/reservation-thresholds"
            name="Reservation Thresholds"
            icon={<ClockIcon />}
          />
        </SuperAdmin>
        <Can permissions="accounting.invoicereport.read">
          <Item
            crumbs={["Operator Invoices"]}
            href="/operator-invoices"
            name="Operator Invoices"
            icon={<DocumentTextIcon />}
          />
        </Can>
        <Can permissions="gtfs.read">
          <Item
            crumbs={["Menaxhimi i GTFS"]}
            name="Menaxhimi i GTFS"
            icon={<MapIcon />}
          >
            <Item
              crumbs={["Menaxhimi i GTFS", "Linjat"]}
              href="/gtfs/lines"
              name="Linjat"
            />
            <Item
              crumbs={["Menaxhimi i GTFS", "Shapes"]}
              href="/gtfs/shapes"
              name="Shapes"
            />
            <Item
              crumbs={["Menaxhimi i GTFS", "Stacionet"]}
              href="/gtfs/stations"
              name="Stacionet"
            />
            <Item
              crumbs={["Menaxhimi i GTFS", "Bllokimet"]}
              href="/gtfs/blocks"
              name="Bllokimet"
            />
            <Item
              crumbs={["Menaxhimi i GTFS", "Feeds"]}
              href="/gtfs/feeds"
              name="Feeds"
            />
            <Item
              crumbs={["Menaxhimi i GTFS", "Enrollment Log"]}
              href="/gtfs/enrollment-log"
              name="Enrollment Log"
            />
          </Item>
        </Can>
        {/* <SuperAdmin>
          <Item
            crumbs={["Operatoret", "Link email operatorin"]}
            href="/operator/link"
            name="Link email me operatorin"
            icon={<LinkIcon />}
          />
        </SuperAdmin> */}
        {/* <Item
        crumbs={["Financat"]}
        href="/finances"
        name="Financat"
        icon={<CreditCardIcon />}
      /> */}
        <Can permissions="mcp.mcp.read">
          <Item
            crumbs={["MCP Settings"]}
            href="/mcp-settings"
            name="MCP Settings"
            icon={<WrenchScrewdriverIcon />}
          />
        </Can>
        <SuperAdmin>
          <Item
            crumbs={["Customer Feedback"]}
            href="/customer-feedback"
            name="Customer Feedback"
            icon={<ChatBubbleLeftRightIcon />}
          />
        </SuperAdmin>
      </ul>
      <VideoTutorials />
    </>
  );
};

export default Body;
